<div class="stepper">
  <nz-steps [nzCurrent]="currentStep">
    <nz-step nzTitle="Create Collaboration"></nz-step>
    <nz-step nzTitle="Associate Dataset(s)"></nz-step>
    <nz-step nzTitle="Partners & Invitations"></nz-step>
    <nz-step nzTitle="View Summary"></nz-step>
  </nz-steps>
</div>
